
document.addEventListener("DOMContentLoaded", function () {
    const toggleButton = document.querySelector(".dropdown-toggle");
    const dropdownContent = document.querySelector(".dropdown-content");

    if (!toggleButton) return;
    toggleButton.addEventListener("click", function () {
        if (dropdownContent) {
            dropdownContent.classList.toggle("active");
        }
        const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
        toggleButton.setAttribute("aria-expanded", !isExpanded);
    });
});
